import * as React from 'react';
import {
  makeStyles,
  Button,
  withStyles,
  MenuProps,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText
} from '@material-ui/core';
import { AccountCircle, ArrowDropDown, ExitToApp } from '@material-ui/icons';
import { neutral } from '../theme/colors';

export interface UserMenuProps {
  userName: string;
  handleLogout: () => void;
}

const useStyles = makeStyles({
  root: {
    overflow: 'hidden'
  },
  menuButton: {
    padding: '7px 8px',
    marginBottom: 2,
    '& .MuiButton-label': {
      textTransform: 'none',
      fontFamily: 'Montserrat',
      fontSize: 14,
      fontWeight: 'normal',
      color: '#00223c'
    }
  },
  userIcon: {
    width: 17,
    height: 17
  }
});

const StyledMenu = withStyles({
  paper: {
    border: '1px solid #d3d4d5'
  }
})((props: MenuProps) => (
  <Menu
    elevation={0}
    getContentAnchorEl={null}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'center'
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'center'
    }}
    {...props}
  />
));

/**
 * Render a logged in user menu with logout option
 */
const UserMenu = ({ userName, handleLogout }: UserMenuProps) => {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState<Element | null>();

  const openMenu = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    setAnchorEl(event.currentTarget);
  };

  const closeMenu = () => {
    setAnchorEl(null);
  };

  return (
    <React.Fragment>
      <div className={classes.root}>
        <Button
          aria-controls="customized-menu"
          aria-haspopup="true"
          onClick={openMenu}
          className={classes.menuButton}
          size="large"
          startIcon={<AccountCircle className={classes.userIcon} />}
          endIcon={<ArrowDropDown htmlColor={neutral[600]} />}
        >
          {userName}
        </Button>
      </div>
      <StyledMenu id="customized-menu" anchorEl={anchorEl} keepMounted open={Boolean(anchorEl)} onClose={closeMenu}>
        <MenuItem onClick={handleLogout}>
          <ListItemIcon>
            <ExitToApp />
          </ListItemIcon>
          <ListItemText primary="Logout" />
        </MenuItem>
      </StyledMenu>
    </React.Fragment>
  );
};

export default UserMenu;
